document.addEventListener('DOMContentLoaded', async () => {
  let events = [];
  let types = [];
  let flyers = [];
  let selectedStores = [];
  let selectedDate = null;

  // ### Get all events data initialized
  const getEventsData = async () => {
    let data = await fetch(`/tools/my-kah-api/events/getAll`, {
      cache: 'no-store',
    });
    events = await data.json();

    // Filter and sort events
    const today = new Date();
    events = events
      .filter((event) => new Date(event.start) >= today)
      .sort((a, b) => new Date(a.start) - new Date(b.start));

    return events;
  };

  const getTypesData = async () => {
    try {
      let startTime = Date.now();
      while (events.length === 0 && Date.now() - startTime < 5000) {
        await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for 100ms before checking again
      }
      if (events.length === 0) {
        throw new Error('Failed to load events data within 5 seconds.');
      }

      events.forEach((e) => {
        if (!types.includes(e.type)) {
          types.push(e.type);
        }
      });
      return types;
    } catch (error) {
      console.error('Error processing event types:', error);
    }
  };

  const getFlyers = async () => {
    const flyersRes = await fetch(`/tools/my-kah-api/events/flyers/getAll`, {
      cache: 'no-store',
    });
    const flyers = await flyersRes.json();
    return flyers;
  };

  // ### Set data
  events = await getEventsData();
  types = await getTypesData();
  flyers = await getFlyers();

  // ### Build UI
  /* Filters */
  const filters = new EventsFilters(types, events, flyers);
  filters.render('#events .filter-inputs');

  filters.onFilterChange((filteredEventData) => {
    events = filteredEventData;
    const filteredEvents = handleFilteredEvents();

    // Sync calendar's selectedDate
    calendar.selectedDate = selectedDate;

    // Only filter by date for display
    let eventsToShow = filteredEvents;
    if (selectedDate) {
      eventsToShow = filteredEvents.filter((event) => {
        const eventDate = new Date(event.start);
        return eventDate.toDateString() === selectedDate.toDateString();
      });
    }

    if (eventsToShow.length > 0) {
      eventsList.rebuild(eventsToShow);
      eventsList.render('#events-list');
      calendar.rebuild(filteredEvents); // Calendar shows all filtered events, not just the selected date
    } else {
      document.querySelector('#events-list').innerHTML = '<p>No events available for the selected filters.</p>';
      calendar.rebuild(filteredEvents);
    }

    // Update search params for event type
    const selectedEventTypes = Array.from(filters.selectedEventTypes);
    if (selectedEventTypes.length === filters.eventTypes.length) {
      // If all event types are selected, remove the filterEvent parameter
      updateSearchParams('filterEvent', null);
    } else {
      updateSearchParams('filterEvent', selectedEventTypes.length ? selectedEventTypes[0] : null);
    }
  });

  /* Events List */
  const eventsList = new EventsList(events, flyers);
  eventsList.render('#events-list');

  eventsList.onPageChange = (page) => {
    updateSearchParams('page', page);
  };

  /* Calendar */
  const onCalDateSelect = (selectedDate) => {
    const filteredEvents = events.filter((event) => {
      const eventDate = new Date(event.start);
      return selectedDate && eventDate.toDateString() === selectedDate.toDateString();
    });
    eventsList.rebuild(filteredEvents);
    eventsList.render('#events-list');
    updateSearchParams('selectedDate', selectedDate.toISOString().split('T')[0]);
  };

  const onCalClearFilters = () => {
    selectedDate = null;
    updateSearchParams('selectedDate', null);
    eventsList.rebuild(events);
    eventsList.render('#events-list');
  };

  const calendar = new Calendar(events, onCalDateSelect, onCalClearFilters);

  calendar.render('#events-calendar');

  calendar.onDateSelect = (date) => {
    selectedDate = date;
    updateSearchParams('selectedDate', date.toISOString().split('T')[0]);

    const filteredEvents = handleFilteredEvents();

    // Only filter by date for display
    let eventsToShow = filteredEvents;
    if (selectedDate) {
      eventsToShow = filteredEvents.filter((event) => {
        const eventDate = new Date(event.start);
        return eventDate.toDateString() === selectedDate.toDateString();
      });
    }

    eventsList.rebuild(eventsToShow);
    eventsList.render('#events-list');
  };

  /* Clear Filters Button */
  const clearFilterButton = document.getElementById('clear-filters-button');
  clearFilterButton.addEventListener('click', () => {
    selectedDate = null;
    selectedStores = [];
    filters.selectedEventTypes.clear(); // Clear event type filters

    // Hide filter button
    clearFilterButton.classList.add('hidden');

    // Reset store selector
    const formElement = document.querySelector('.store-selector__form');
    if (formElement && formElement.storeSelector) {
      formElement.storeSelector.setSelectedStores([]);
      formElement.storeSelector.updateSelectedStoreIndicator(); // Update indicator
    }

    // Reset selected date if needed
    const dateSelected = document.querySelector('.calendar-day-selected') ?? false;
    if (!!dateSelected) {
      dateSelected.classList.remove('calendar-day-selected');
      calendar.selectedDate = null;
      calendar.updateCalendar();
    }

    // Hide event summary if needed
    const flyerSummaryContainer = document.querySelector('#events .events-container #filter-summary');
    if (flyerSummaryContainer) {
      flyerSummaryContainer.innerHTML = '';
      flyerSummaryContainer.classList.add('hidden');
    }

    // Reset event type buttons
    document.querySelectorAll('.events-filters-form input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.value === 'select-all') {
        checkbox.checked = true;
        checkbox.parentElement.classList.add('active');
      } else {
        checkbox.checked = false;
        checkbox.parentElement.classList.remove('active');
      }
    });

    // Clear URL parameters
    updateSearchParams('clear', true);

    // Notify filters change
    filters.notifyFilterChange();

    // Reload all events
    const filteredEvents = handleFilteredEvents();
    eventsList.rebuild(filteredEvents);
    eventsList.render('#events-list');
    calendar.rebuild(filteredEvents);
  });

  // ### Add functionality
  /* Checking for event filtering */
  const handleFilteredEvents = () => {
    let filteredEvents = events;

    // Do NOT filter by date here!

    // Filter by store
    if (selectedStores.length > 0) {
      filteredEvents = filteredEvents.filter((event) => {
        const host = event.host.toLowerCase().replace(/\s+/g, '-');
        return selectedStores.some((storeData) => host === storeData.id);
      });
    }

    // Filter by event type
    const selectedEventTypes = Array.from(filters.selectedEventTypes);
    if (selectedEventTypes.length > 0) {
      filteredEvents = filteredEvents.filter((event) => selectedEventTypes.includes(event.type));
    }

    return filteredEvents.length > 0 ? filteredEvents : [];
  };

  const formElement = document.querySelector('.store-selector__form');
  if (formElement && formElement.storeSelector) {
    const storeSelector = formElement.storeSelector;

    // Add event listener to update data whenever a checkbox changes
    formElement.addEventListener('change', () => {
      selectedStores = storeSelector.getSelectedStores();
      if (!selectedStores) return;

      const storeIds = selectedStores.map((store) => store.id);
      updateSearchParams('filterStore', storeIds.length ? storeIds.join(',') : null); // Encode multiple stores

      const filteredEvents = handleFilteredEvents();

      if (filteredEvents.length > 0) {
        eventsList.rebuild(filteredEvents);
        eventsList.render('#events-list');
        calendar.rebuild(filteredEvents);
      } else {
        document.querySelector('#events-list').innerHTML = '<p>No events available for the selected filters.</p>';
      }
    });
  }

  const applySearchParams = () => {
    const params = new URLSearchParams(window.location.search);

    // Apply event type filter
    const eventType = params.get('filterEvent');
    if (eventType) {
      document.querySelector(`#events .filter-inputs input[value="${eventType}"]`).checked = true;
      filters.toggleEventType(eventType);
    }

    // Apply store filter
    const storeParam = params.get('filterStore');
    if (storeParam) {
      const storeIds = storeParam.split(','); // Decode multiple stores
      selectedStores = storeIds.map((id) => ({ id }));
      formElement.storeSelector.setSelectedStores(storeIds);
      formElement.storeSelector.updateSelectedStoreIndicator(); // Update indicator
    }

    // Apply selected date
    const date = params.get('selectedDate');
    if (date) {
      selectedDate = new Date(date);
      calendar.selectedDate = selectedDate;
      calendar.updateCalendar();
    }

    // Apply pagination
    const page = params.get('page');
    if (page) {
      eventsList.currentPage = parseInt(page, 10);
    }

    // Open flyer if flyerOpen param is present
    const flyerId = params.get('flyerOpen');
    if (flyerId) {
      eventsList.openFlyer(flyerId);
    }

    // Trigger filtering after applying all params
    const filteredEvents = handleFilteredEvents();
    if (filteredEvents.length > 0) {
      eventsList.rebuild(filteredEvents);
      eventsList.render('#events-list');
      calendar.rebuild(filteredEvents);
    } else {
      document.querySelector('#events-list').innerHTML = '<p>No events available for the selected filters.</p>';
    }
  };

  let prevUrl = window.location.href;

  const updateSearchParams = (key, value) => {
    try {
      const theParams = ['selectedDate', 'filterEvent', 'filterStore', 'page', 'flyerOpen', 'view'];

      // If we're clearing all filters, strip them out
      if (key === 'clear') {
        const urlObj = new URL(window.location.href);
        theParams.forEach((paramKey) => {
          if (paramKey !== 'view') {
            urlObj.searchParams.delete(paramKey);
          }
        });
        history.replaceState({}, '', urlObj.toString());
        prevUrl = window.location.href; // Update prevUrl after change
        return;
      }

      const isFlyerOpen = document.getElementById('flyers').dataset.displayed;
      if (isFlyerOpen) {
        eventsList.closeFlyer();
      }

      // Build new URL with allowed parameters only
      const currentUrl = new URL(window.location.href);
      const searchParams = currentUrl.searchParams;

      // Remove disallowed parameters
      [...searchParams.keys()].forEach((paramKey) => {
        if (!theParams.includes(paramKey)) {
          searchParams.delete(paramKey);
        }
      });

      // Update or remove the target param
      if (value !== null && value !== undefined) {
        searchParams.set(key, value);
      } else {
        searchParams.delete(key);
      }

      // Update the visible "clear filters" button state
      const clearFiltersButton = document.getElementById('clear-filters-button');
      const viewFilteredOut = [...searchParams.keys()].some((paramKey) => {
        return theParams.includes(paramKey) && paramKey !== 'view' && searchParams.get(paramKey) !== null;
      });
      viewFilteredOut ? clearFiltersButton.classList.remove('hidden') : clearFiltersButton.classList.add('hidden');

      // Push or replace the sanitized URL depending on flyerOpen param
      const absoluteUrl = `${window.location.origin}${currentUrl.pathname}?${searchParams.toString()}`;

      history.replaceState({}, '', absoluteUrl);
      prevUrl = window.location.href; // Update prevUrl after change

      // Remove the "alia_user" parameter after a short delay
      setTimeout(() => {
        const isAliaUser = new URLSearchParams(window.location.search).get('alia_user');
        if (isAliaUser) {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.delete('alia_user');
          history.replaceState({}, '', `${currentUrl.pathname}?${searchParams.toString()}`);
          prevUrl = window.location.href; // Update prevUrl after change
        }
      }, 0);
    } catch (error) {
      console.error('Error updating search params:', error);
    }
  };

  // Apply search parameters on page load
  applySearchParams();
  window.addEventListener('popstate', () => {
    const currentUrl = window.location.href;
    const params = new URLSearchParams(window.location.search);
    const flyers = document.getElementById('flyers');
    const flyerId = params.get('flyerOpen') || false;
    if (flyerId) {
      eventsList.openFlyer(flyerId);
    } else {
      eventsList.closeFlyer();
    }
    prevUrl = currentUrl;
  });
});